export const getFamilyIntracranial = (familyIntracranial) => {
  const entries = familyIntracranial?.taskEntry;
  if (!entries) {
    return '';
  }

  return entries.doYouHaveAFamilyHistoryOfIntracranialAneurysms === 'yes'
    ? 'Yes'
    : 'No';
};
